import BaseList from '@/common/components/BaseList';

export * from '@/common/components/BaseList';

export default BaseList;
